// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LTJ_","label":"styles_label__3oLsY"};